"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_LMIA_USE_OF_REP_QUESTION_GROUPS = exports.COMPANY_LMIA_STREAM_APPLICATION_QUESTION_GROUPS = exports.COMPANY_LMIA_GENERAL_APPLICATION_QUESTION_GROUPS = exports.COMPANY_LMIA_ROLE_QUESTION_GROUPS = exports.COMPANY_LMIA_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.COMPANY_LMIA_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "COMPANY_INTAKE_EMPLOYER",
        title: "Employer",
        subtitle: "Please fill in all required detailed below about your company",
        id: 113,
        content: [
            Question["Legal Business Name"].label("CG_1"),
            Question["Business operating name"].label("CG_37"),
            Question["Do you have an additional business operating name that you would like to include?"]
                .label("CG_38")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Additional business operating name"].label("CG_39"),
            ]),
            Question["15-digit CRA Payroll Number"].label("CG_10"),
            Question["Is this business a recruitment or placement agency?"].label("CG_36"),
            Question["Industrial sector"].label("CG_40"),
            Question["Type of business"].label("CG_41"),
            Question["Size of business"].label("CG_42"),
            Question["Website URL"].label("CG_11"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_INTAKE_BUSINESS_PROFILE",
        title: "Business Profile",
        id: 114,
        content: [
            Question["Learning opportunities being offered"].label("CG_43"),
            Question["Workplace accommodations being offered"].label("CG_44"),
            Question["Workplace amenities being offered"].label("CG_45"),
            Question["Green initiatives being offered"].label("CG_46"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_INTAKE_LABOUR_MARKET_IMPACT",
        title: "Labour Market Impacts",
        id: 115,
        content: [
            Question["How many employees are employed nationally under your 9-digit CRA business number?"].label("CG_47"),
            Question["Did the business report more than $5 Million (CAD) in annual gross revenue to the CRA during its last tax year?"].label("CG_48"),
            Question["Does the business receive support through Employment Development Canada/Service Canada's Work-Sharing program?"]
                .label("CG_49")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Provide details regarding the support you are receiving through the Work-Sharing program"].label("CG_50"),
            ]),
            Question["Is there a labour dispute in progress at any of the job offer work locations?"]
                .label("CG_51")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details regarding the labour dispute"].label("CG_52"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_INTAKE_POTENTIAL_BENEFITS",
        title: "Potential Benefits",
        id: 116,
        content: [
            Question["Will hiring a TFW result in the direct job creation or job retention of Canadians/permanent residents?"]
                .label("CG_53")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details to explain why hiring a TFW will result in the direct job creation or job retention of Canadians/permanent residents"].label("CG_54"),
            ]),
            Question["Will hiring a TFW result in the development or transfer of skills and knowledge for the benefit of Canadians/permanent residents?"]
                .label("CG_55")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details to explain why hiring a TFW will result in the development or transfer of skills and knowledge for the benefit of Canadians/permanent residents"].label("CG_56"),
            ]),
            Question["Will hiring a TFW fill a labour shortage?"]
                .label("CG_57")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details to explain why hiring a TFW will fill labour shortage"].label("CG_58"),
            ]),
            Question["Please describe any other benefits to the Canadian labour market that will result from offering this job to a TFW"].label("CG_59"),
        ],
    }),
];
exports.COMPANY_LMIA_ROLE_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "COMPANY_LMIA_ROLE_HOURS_PAY",
        title: "Hours and Pay",
        subtitle: "Please enter the details about the duration of the foreign workers employment",
        id: 118,
        content: [
            Question["Thinking of the occupation into which you wish to hire a foreign worker, are there any employees currently working in this same occupation, with the same skills and years of experience, at the primary work location?"]
                .label("ROLE_35")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["What is the lowest wage for these employees per hour?"].label("ROLE_36"),
                Question["What is the highest wage for these employees per hour?"].label("ROLE_37"),
            ]),
            Question["How many hours will the TFW work each day?"].label("ROLE_38"),
            Question["How many hours will the TFW work each week?"].label("ROLE_39"),
            Question["Will the TFW have an atypical schedule without standard daily or weekly hours?"]
                .label("ROLE_40")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details regarding the atypical schedules"].label("ROLE_41"),
            ]),
            Question["Is your job offer for a full-time position (average of at least 30 hours per week) throughout the duration of employment covered by this Labour Market Impact Assessment?"]
                .label("ROLE_42")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Explain why your job offer is not full-time for the duration of employment covered by this LMIA"].label("ROLE_43"),
            ]),
            Question["Is there an overtime rate?"]
                .label("ROLE_44")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["What is the overtime wage in Canadian dollars per hour being offered to the TFW? (must meet provincial/territorial requirements)"].label("ROLE_45"),
                Question["Overtime will be determined by"].label("ROLE_46"),
                Question["After how many hours per week does the overtime rate begin?"].label("ROLE_46"),
            ]),
            Question["Will the TFW be paid any contingent wages (e.g. piecework, mileage, commissions, guaranteed bonuses, or predictable overtime)?"]
                .label("ROLE_47")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details about the contingent wages"].label("ROLE_48"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_LMIA_ROLE_JOB_OFFER",
        title: "Job Offer Details",
        subtitle: "Please enter the details about the job offer",
        id: 119,
        content: [
            Question["Describe, in your own words and in as much detail as possible, the main duties of the position offered to the TFW(s)"].label("ROLE_49"),
            Question["How is the position requested in this application necessary for the operations of the business and explain the impact on your operations should the position remain vacant?"].label("ROLE_50"),
            Question["Does this position require the ability to communicate in a specific language?"]
                .label("ROLE_51")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["This position requires the ability to communicate orally in"].label("ROLE_52"),
                Question["This position requires the ability to communicate in writing in"].label("ROLE_53"),
                Question["Does this position require the ability to communicate in a language other than English or French?"]
                    .label("ROLE_53")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["Indicate the other language required for the position and provide a rationale."].label("ROLE_54"),
                ]),
            ])
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Please provide a rationale to why the ability to communicate, as one of the two official languages should not be a minimum requirement."].label("ROLE_55"),
            ]),
            Question["Does this job have any minimum education requirements?"]
                .label("ROLE_56")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Indicate the minimum education requirements for this job"].label("ROLE_57"),
                Question["Describe the specific diploma/certificate, degree, Ph.D or other education requirements that the job requires"].label("ROLE_58"),
            ]),
            Question["List any minimum experience/skills requirements of the job (include years of experience and/or occupational designations such as CPA, RN, P.Eng)"].label("ROLE_59"),
            Question["Is the occupation regulated at a federal/provincial/territorial level and does it require occupational certification, licensing or registration?"]
                .label("ROLE_60")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Indicate the type of occupational certification, licensing or registration required and the name of the issuing body/authority"].label("ROLE_61"),
            ]),
            Question["Will the hiring of TFWs requested in this application lead to job losses, or a reduction in work hours, now or in the foreseeable future, for Canadians/permanent resident employees in your workforce or to the Canadian workforce more generally as a result of lay-offs including those resulting from outsourcing, off-shoring or other factors related to utilizing a TFW?"]
                .label("ROLE_72")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Provide details on the impact of hiring the TFW(s) on your workforce and the Canadian workforce more generally."].label("ROLE_73"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_LMIA_ROLE_EMPLOYMENT_BENEFITS",
        title: "Employment Benefits",
        subtitle: "Please enter the details about the job employment benefits",
        id: 120,
        content: [
            Question["Is the position part of a union?"].label("ROLE_62"),
            Question["Will you be providing any benefits to the TFW?"]
                .label("ROLE_63")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Will you be providing disability insurance? "].label("ROLE_64"),
                Question["Will you be providing dental insurance?"].label("ROLE_65"),
                Question["Will you enrol the TFW in an employer-provided pension?"].label("ROLE_66"),
                Question["Will you be providing extended medical insurance? (e.g. prescription drugs, paramedical services, medical services and equipment)"].label("ROLE_67"),
                Question["Will you be providing any other benefits?"]
                    .label("ROLE_68")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["In the previous question, you indicated that there are other benefits. Please explain."].label("ROLE_69"),
                ]),
            ]),
            Question["Enter the number of paid vacation days provided"].label("ROLE_70"),
            Question["Enter the vacation pay percentage (of gross salary)"].label("ROLE_71"),
        ],
    }),
];
exports.COMPANY_LMIA_GENERAL_APPLICATION_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "COMPANY_LMIA_GENERAL_APPLICATION_EMPLOYMENT",
        title: "Employment Information",
        subtitle: "Please enter the details about the wage, work location and employment duration",
        id: 121,
        content: [
            Question["Wage Information"].label("HEAD_12"),
            Question["What is the regular (non-overtime) wage in Canadian dollars per hour being offered to the TFW?"].label("LMIA_1"),
            Question["Was the wage converted from a monthly, yearly or piecework salary, or a currency other than Canadian dollars, or both?"]
                .label("LMIA_2")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide a detailed explanation, including the calculations used if applicable, of how you converted the salary to Canadian dollars per hour"].label("LMIA_3"),
            ]),
            Question["Work Location Information"].label("HEAD_13"),
            Question["What is the business operating name of this location?"].label("LMIA_4"),
            Question["Describe, in your own words and in as much detail as possible, the principal business activity at this work location"].label("LMIA_5"),
            Question["Describe, in your own words and in as much detail as possible, any safety concerns or hazards associated with the principal business activity or site"].label("LMIA_6"),
            Question["Employment Duration Information"].label("HEAD_14"),
            Question["What is the expected employment duration determinant?"].label("LMIA_7"),
            Question["What is the expected employment duration?"].label("LMIA_8"),
            Question["What is the expected employment start date?"].label("LMIA_9"),
            Question["Labour Market Impact"].label("HEAD_14"),
            Question["In the last 12 months, did the employer lay off any employees working in the position(s) being requested in this application?"]
                .label("LMIA_10")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["How many Canadians/permanent residents did you lay off in the last 12 months?"].label("LMIA_11"),
                Question["How many TFWs (Temporary Foreign Workers) did you lay off in the last 12 months?"].label("LMIA_12"),
                Question["Provide reason(s) for the layoff(s)"].label("LMIA_13"),
            ]),
        ],
    }),
];
exports.COMPANY_LMIA_STREAM_APPLICATION_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_GTS",
        title: "Global Talent Stream (GTS)",
        id: 122,
        content: [
            Question["Are you seeking to apply to Category A or Category B of the Global Talent Stream?"]
                .label("LMIA_14")
                .ifAnswerEquals("Category A")
                .renderTheseQuestions([
                Question["Select the Designated Referral Partner"].label("LMIA_15"),
            ])
                .ifAnswerEquals("Category B")
                .renderTheseQuestions([
                Question["Select an occupation category from the list"].label("LMIA_16"),
            ]),
            // TODO: questions already created and commented out
            // Question[
            //   "Please select the top 3-4 activities you'd like to commit to for the Labour Market Benefits Plan"
            // ].label("LMIA_17"),
            // Question[
            //   "Please provide estimates and/or values of how much you could commit to each activity"
            // ].label("LMIA_18"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_SEASONAL_AGRICULTURE",
        title: "LMIA Seasonal Agriculture Worker Program",
        id: 123,
        content: [
            Question["Please indicate the arrival date"].label("LMIA_19"),
            Question["Please indicate the departure date"].label("LMIA_20"),
            Question["Which of the following are you applying for?"].label("LMIA_21"),
            Question["Will substitute workers not be accepted in situations where previously identified workers are not available?"].label("LMIA_22"),
            Question["Have any of the TFWs worked for 5 or more consecutive years at your place of employment?"]
                .label("LMIA_23")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Will you provide a weekly recognition payment of between $4 and $128?"].label("LMIA_24"),
            ])
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Please explain why you are not providing a weekly recognition payment"].label("LMIA_25"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_AGRICULTURAL_ALL",
        title: "LMIA Agricultural",
        id: 124,
        content: [
            Question["Total number of Canadian/permanent resident workers in the same occupation working at the same location expected to be employed this year/season"].label("LMIA_26"),
            Question["Total number of Canadian/permanent resident workers in the same occupation working at the same location employed last year/season"].label("LMIA_27"),
            Question["Total number of TFWs in the same occupation working at the same location expected to be employed this year/season"].label("LMIA_28"),
            Question["Total number of TFWs in the same occupation working at the same location employed last year/season"].label("LMIA_29"),
            Question["Did the number of workers, which includes Canadian citizens, permanent residents and TFWs change from last year/season?"]
                .label("LMIA_30")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["In the previous question, you indicated that the number of workers changed from last year/season. Please explain:"].label("LMIA_31"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_AGRICULTURE",
        title: "LMIA Agricultural Stream",
        id: 125,
        content: [
            Question["Is this LMIA application for replacement workers?"]
                .label("LMIA_32")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Enter the LMIA # you are requesting replacement TFWs for"].label("LMIA_33"),
                Question["For the LMIA # entered, how many of the requested TFWs are currently employed?"].label("LMIA_34"),
            ]),
            Question["Are you providing on-farm or off-farm housing?"]
                .label("LMIA_35")
                .ifAnswerEquals("On-Site")
                .renderTheseQuestions([
                Question["How much will you deduct per week?"].label("LMIA_36"),
            ])
                .ifAnswerEquals("Off-Site")
                .renderTheseQuestions([
                Question["Is the occupation in which the TFW will work a lower-skilled or higher-skilled occupation?"]
                    .label("LMIA_37")
                    .ifAnswerEquals("Lower")
                    .renderTheseQuestions([
                    Question["How much will you deduct per week?"].label("LMIA_36"),
                ])
                    .ifAnswerEquals("Higher")
                    .renderTheseQuestions([
                    Question["How many TFWs is the Market Rental Rate being divided between?"].label("LMIA_39"),
                    Question["What is the Market Rental Rate per month?"].label("LMIA_40"),
                    Question["What is the rent per TFW per month?"].label("LMIA_41"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_RECRUITMENT",
        title: "LMIA Recruitment",
        id: 126,
        content: [
            Question["Is the position subject to a variation in minimum advertising requirements as listed on the TFW Program website, including the Quebec Facilitated Process?"]
                .label("LMIA_42")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Specify the applicable variation and provide a rationale for meeting its criteria"].label("LMIA_43"),
                Question["In addition to applying for the recruitment variation, would you like to provide any recruitment details for this application?"]
                    .label("LMIA_44")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["Did you advertise using Job Bank?"]
                        .label("LMIA_45")
                        .ifAnswerEquals(answer_1.answer.yes)
                        .renderTheseQuestions([
                        Question["Please enter the job posting number advertised on Job Bank"].label("LMIA_46"),
                    ])
                        .ifAnswerEquals(answer_1.answer.no)
                        .renderTheseQuestions([
                        Question["Provide an explanation of the advertising method and a rationale for not utilizing Job Bank"].label("LMIA_47"),
                    ]),
                ]),
            ]),
            Question["How many applications/resumes were received from Canadians/permanent residents?"].label("LMIA_48"),
            Question["How many Canadians/permanent resident applicants were interviewed?"].label("LMIA_49"),
            Question["How many Canadians/permanent residents were offered the position?"].label("LMIA_50"),
            Question["How many Canadians/permanent residents were hired?"].label("LMIA_51"),
            Question["How many Canadians/permanent residents declined a job offer?"].label("LMIA_52"),
            Question["How many Canadians/permanent residents applied but were not interviewed or offered the position?"].label("LMIA_53"),
            Question["For each unsuitable Canadian/permanent resident applicant, provide an explanation as to why the candidate did not meet the requirements of the position. Do not provide the names of the candidates."].label("LMIA_54"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_EXPRESS_ENTRY",
        title: "Express Entry",
        id: 127,
        content: [
            Question["Are you applying for an LMIA to support a TFW?"].label("LMIA_55"),
            Question["Is this application being made jointly with another employer?"].label("LMIA_56"),
            Question["Who is currently filling the duties and responsibilities of the position?"].label("LMIA_57"),
            Question["How did you find or identify the TFW for this position?"].label("LMIA_58"),
            Question["Have you previously employed or do you currently employ any of these TFW on an LMIA-based work permit or an LMIA-exempt work permit?"]
                .label("LMIA_59")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please indicate the start and end dates of any periods when you employed these TFW. Also indicate the start and end dates of any breaks in employment."].label("LMIA_60"),
                Question["How did you determine that the TFW possessed the qualifications for the job?"].label("LMIA_61"),
                Question["How and when did you offer this job to the TFW(s)?"].label("LMIA_62"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_CAREGIVER",
        title: "In-Home Caregiver",
        id: 128,
        content: [
            Question["Will more than one individual act as the employer of the TFW?"]
                .label("LMIA_63")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["First name(s)"].label("LMIA_64"),
                Question["Middle name"].label("LMIA_65"),
                Question["Last name"].label("LMIA_66"),
                Question["Job Title"].label("LMIA_67"),
                Question["Is the contact number North American?"].label("LMIA_68"),
                Question["Telephone number"].label("LMIA_69"),
                Question["Telephone number extension"].label("LMIA_70"),
                Question["Is there an alternate telephone #?"]
                    .label("LMIA_71")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["Telephone number (Alternate)"].label("LMIA_72"),
                    Question["Telephone number extension (Alternate)"].label("LMIA_73"),
                ]),
                Question["Email address"].label("LMIA_74"),
                Question["Language of correspondence"].label("LMIA_75"),
                Question["Second Employer Physical Address"].label("HEAD_15"),
                Question["Country or Territory"].label("LMIA_76"),
                Question["Address Line 1"].label("LMIA_77"),
                Question["Address Line 2"].label("LMIA_78"),
                Question["City or Town"].label("LMIA_79"),
                Question["Postal Code"].label("LMIA_80"),
                Question["Is the mailing address the same as the physical address?"]
                    .label("LMIA_81")
                    .ifAnswerEquals(answer_1.answer.no)
                    .renderTheseQuestions([
                    Question["Second Employer Mailing Address"].label("HEAD_16"),
                    Question["Country or Territory"].label("LMIA_82"),
                    Question["Address Line 1"].label("LMIA_83"),
                    Question["Address Line 2"].label("LMIA_84"),
                    Question["City or Town"].label("LMIA_85"),
                    Question["Postal Code"].label("LMIA_86"),
                ]),
                Question["Enter the declared income of the second employer as per line 150 of the CRA Notice of Assessment"].label("LMIA_87"),
                Question["Does the second employer live in the same household as the first employer?"]
                    .label("LMIA_88")
                    .ifAnswerEquals(answer_1.answer.no)
                    .renderTheseQuestions([
                    Question["Locate the LICO figure that applies to the second employer's household and input it"].label("LMIA_89"),
                ]),
            ]),
            Question["Financial Ability"].label("HEAD_17"),
            Question["Enter the declared income of the first employer as per line 150 of the CRA Notice of Assessment"].label("LMIA_90"),
            Question["Locate the LICO figure that applies to the first employer's household and input it"].label("LMIA_91"),
            Question["Enter the total annual wage to be paid to the foreign caregiver"].label("LMIA_92"),
            Question["Is there additional income available to pay the TFW that was not declared on line 150 of the CRA Notice of Assessment (e.g. savings or provincial grants) from either the first or second employer (if applicable)?"]
                .label("LMIA_93")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please specify the specific type(s) and amount(s) of supplementary available income"].label("LMIA_94"),
            ]),
            Question["Care Required"].label("HEAD_18"),
            Question["How many people is the employer responsible for financially supporting (i.e. dependents)? Consider dependents of both employers if applicable, including any dependents not living in the household"].label("LMIA_95"),
            Question["Are you providing accommodations for the TFW in the home where the care will be provided?"]
                .label("LMIA_96")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Is the live-in arrangement voluntary?"]
                    .label("LMIA_97")
                    .ifAnswerEquals("Voluntary")
                    .renderTheseQuestions([
                    Question["Will the TFW have their own bedroom?"].label("LMIA_98"),
                ])
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What is the length of the bedroom in feet (ft)?"].label("LMIA_99"),
                    Question["What is the width of the bedroom in feet (ft)?"].label("LMIA_100"),
                    Question["Provide additional details about furniture and/or services"].label("LMIA_101"),
                    Question["Does the bedroom that will be provided to the TFW include"].label("LMIA_102"),
                ])
                    .ifAnswerEquals(answer_1.answer.no)
                    .renderTheseQuestions([
                    Question["Please explain why the TFW will not have their own bedroom"].label("LMIA_103"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_HIGH_WAGE_TRANSITION",
        title: "High-wage Transition Plan",
        id: 129,
        content: [
            Question["Is this LMIA application for a seasonal occupation?"]
                .label("LMIA_104")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["What month does your peak employment season start in every year?"].label("LMIA_105"),
                Question["What month does your peak employment season end in every year?"].label("LMIA_106"),
                Question["What was your total number of Canadian/permanent resident workers during the previous peak season?"].label("LMIA_107"),
                Question["What was your total number of TFWs during the previous peak season?"].label("LMIA_108"),
            ]),
            Question["How many Canadians/permanent residents are currently employed in the occupation at the work location?"].label("LMIA_109"),
            Question["How many TFWs are currently employed in the occupation at the work location?"].label("LMIA_110"),
            Question["A transition plan is mandatory for employers hiring TFWs with a rate of pay equal to or above the provincial/territorial median wage. Do you wish to be considered for an exemption from the transition plan requirement?"]
                .label("LMIA_111")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["What are the transition plan exemption criteria you wish to be considered for?"].label("LMIA_112"),
                Question["Please provide details to support your request for an exemption"].label("LMIA_113"),
            ])
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you completed a Transition Plan for this occupation at this work location before?"]
                    .label("LMIA_114")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["Describe the results of your previous transition plan activities"].label("LMIA_115"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_APPLICATION_LMIA_HIGH_LOW_WAGE",
        title: "High or Low - wage positions",
        id: 130,
        content: [
            Question["Is the occupation for which you are submitting an LMIA on the list of occupations eligible for Quebec's facilitated process and indicates a wage equal to or greater than the provincial median hourly wage?"].label("LMIA_116"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "ROLE_LMIA_JOB_BANK_POSTING_TARGET_AUDIENCE",
        title: "Target Audience",
        id: 131,
        content: [
            Question["Select the type of job that suits your recruitment needs"].label("JOB_BANK_1"),
            Question["Target groups"].label("JOB_BANK_2"),
            Question["Who can apply to this job?"].label("JOB_BANK_3"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "ROLE_LMIA_JOB_BANK_POSTING_DETAILS",
        title: "Job Details",
        id: 132,
        content: [
            Question["Indicate the number of people you are looking to hire"].label("JOB_BANK_4"),
            Question["Workplace information"].label("JOB_BANK_5"),
            Question["Posting duration"].label("JOB_BANK_6"),
            Question["Period of employment"].label("JOB_BANK_7"),
            Question["Job start date"]
                .label("JOB_BANK_8")
                .ifAnswerEquals("Specific date")
                .renderTheseQuestions([
                Question["Start date"].label("JOB_BANK_9"),
                Question["End date"].label("JOB_BANK_10"),
            ]),
            Question["Hours of work"].label("JOB_BANK_11"),
            Question["Would you like to specify the work hours?"]
                .label("JOB_BANK_12")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Start time"].label("JOB_BANK_13"),
                Question["End time"].label("JOB_BANK_14"),
            ]),
            Question["Employment terms options"].label("JOB_BANK_15"),
            Question["What is the monthly salary in CAD?"].label("JOB_BANK_16"),
            Question["How many hours will they be required to work per week?"].label("JOB_BANK_17"),
            Question["Health benefits"].label("JOB_BANK_18"),
            Question["Financial benefits"].label("JOB_BANK_19"),
            Question["Long term benefits"].label("JOB_BANK_20"),
            Question["Other benefits"].label("JOB_BANK_21"),
            Question["If this is a green job, please select all answers that apply"].label("JOB_BANK_22"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "ROLE_LMIA_JOB_BANK_POSTING_REQUIREMENTS",
        title: "Requirements",
        id: 133,
        content: [
            Question["Work setting"].label("JOB_BANK_23"),
            Question["Budgetary responsibility"].label("JOB_BANK_24"),
            Question["Tasks"].label("JOB_BANK_25"),
            Question["Supervision"].label("JOB_BANK_26"),
            Question["Computer and technology knowledge"].label("JOB_BANK_27"),
            Question["Area of specialization"].label("JOB_BANK_28"),
            Question["Security and safety"].label("JOB_BANK_29"),
            Question["Transportation/travel information"].label("JOB_BANK_30"),
            Question["Work conditions and physical capabilities"].label("JOB_BANK_31"),
            Question["Personal suitability"].label("JOB_BANK_32"),
            Question["Select the minimum level of education needed for this job"].label("JOB_BANK_33"),
            Question["How much experience is required?"].label("JOB_BANK_34"),
            Question["What official language(s) are required?"].label("JOB_BANK_35"),
            Question["External job posting website URL"].label("JOB_BANK_36"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "ROLE_LMIA_JOB_BANK_POSTING_HOW_APPLY",
        title: "How to Apply",
        id: 134,
        content: [
            Question["How-to-apply instructions"].label("JOB_BANK_37"),
            Question["Screening questions"].label("JOB_BANK_38"),
        ],
    }),
];
exports.COMPANY_LMIA_USE_OF_REP_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "COMPANY_LMIA_USE_OF_REP_CONTACTS",
        title: "Use of Representative Contacts",
        id: 135,
        content: [
            Question["First name(s)"].label("CG_19"),
            Question["Last name"].label("CG_20"),
            Question["Email address"].label("CG_22"),
            Question["Phone number"].label("CG_21"),
            Question["Telephone number extension"].label("CG_61"),
            Question["Job Title"].label("CG_18"),
            Question["Would you like to add a second authorized representative?"]
                .label("CG_60")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["First name(s)"].label("CG_24"),
                Question["Last name"].label("CG_25"),
                Question["Email address"].label("CG_27"),
                Question["Phone number"].label("CG_26"),
                Question["Telephone number extension"].label("CG_62"),
                Question["Job Title"].label("CG_23"),
            ]),
        ],
    }),
];
